export const localStorageKeys = {
  choosePrice: "choosePrice",
  userInfo: "userInfo",
  orderPlanInfo: "orderPlanInfo",
  makeRequestOrdersDate: "makeRequestOrdersDate",
  makeRequestSubscriptionDate: "makeRequestSubscriptionDate",
  loadGame: "loadGame",
  domainUrl: "domainUrl",
  mixCoursesListID: "mixCoursesListID",
  shuffleAction: "shuffleAction",
  handPlayExercises: "handPlayExercises",
  tricksPlayExercises: "tricksPlayExercises",
  deffensePlayExercises: "deffensePlayExercises",
  defLeadPlayExercises: "defLeadPlayExercises",
  biddingPlayExercises: "biddingPlayExercises",
  biddingInteractivePlayExercises: "biddingInteractivePlayExercises",
  miniBridgeExercises: "miniBridgeExercises",
  reloadPageShuffle: "reloadPageShuffle",
  mobileBoardCoordinates: "mobileBoardCoordinates",
  coordinatesStartHand: "coordinatesStartHand",
  setAllCoursesBidding: "setAllCoursesBidding",
  listCoursesTechnique: "listCoursesTechnique",
  listCoursesTechniqueHandPlay: "listCoursesTechniqueHandPlay",
  listCoursesTechniqueDeffense: "listCoursesTechniqueDeffense",
  mobileBoardCoordinatesForHand: "mobileBoardCoordinatesForHand",
  firstOpenSite: "firstOpenSite",
  shuffleGame: "shuffleGame",
  userPreferences: "userPreferences"
};

export const sessionStorageKeys = {
  shuffleSetting: "shuffleSetting"
};
